// src/firebase.js
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore' // Optional
import { getAuth } from 'firebase/auth' // Optional
import { getStorage } from 'firebase/storage' // Optional

const firebaseConfig = {
  apiKey: "AIzaSyC4VQRWQPziwgXLFd6yC8VzkzS3b5kNz74",
  authDomain: "tuscanyhouse-2ccda.firebaseapp.com",
  projectId: "tuscanyhouse-2ccda",
  storageBucket: "tuscanyhouse-2ccda.firebasestorage.app",
  messagingSenderId: "20064243318",
  appId: "1:20064243318:web:22abed1fd2538724dfd957"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Optional: Initialize services
const db = getFirestore(app)
const auth = getAuth(app)
const storage = getStorage(app)

export { app, db, auth, storage }
